var _a, _b;
import { QAV, DeviceInfo } from 'qunar-react-native';
export const QAV_INTERACTIVE_TAG = 'FlightStats_InteractiveEvents';
let defaultHybridId = (_b = (_a = global.Ext) === null || _a === void 0 ? void 0 : _a.defaults) === null || _b === void 0 ? void 0 : _b.hybridId;
export class QavEvent {
    constructor(source = {}) {
        // the hybirdId who own this log
        this.hybridId = defaultHybridId;
        // qp版本号, by default, use __QP_INFO.version in prod/beta jsbundle
        this.qpVer = global.__QP_INFO ? global.__QP_INFO.version : 0;
        Object.assign(this, source);
    }
}
// 没有ext时，使用DeviceInfo获取hybridid
(function getHybridIdWhileExtNotExist() {
    !defaultHybridId &&
        DeviceInfo.getInfo((DeviceInfoData) => {
            if (DeviceInfoData === null || DeviceInfoData === void 0 ? void 0 : DeviceInfoData.qpInfo) {
                defaultHybridId = DeviceInfoData.qpInfo.hybridid;
            }
        });
})();
export function logEvent(event) {
    QAV.log(QAV_INTERACTIVE_TAG, JSON.stringify(event));
    // eslint-disable-next-line no-console
    console.log(QAV_INTERACTIVE_TAG, JSON.stringify(event));
}
const prefixTag = 'q_design_path_analysis';
/**
 * 访问路径埋点
 * pmo：http://pmo.corp.qunar.com/browse/FD-10369
 * @param info
 */
export function pathAnalysisLog(info) {
    const data = Object.assign({ appcode: defaultHybridId, qpVer: global.__QP_INFO ? global.__QP_INFO.version : 0 }, info);
    QAV.log(prefixTag, JSON.stringify(data));
    // eslint-disable-next-line no-console
    console.info(prefixTag, JSON.stringify(data));
}
